import {AfterViewInit, Component, EventEmitter, Input, Output} from '@angular/core';
import {
  CategoryCode,
  Coverage,
  extractCoverageFromProtection,
  JobRiskClass,
  Protection,
  Sex,
  Version,
} from '@emma-labs/shared/typescript';
import {CardModule} from 'primeng/card';
import {first} from 'rxjs/operators';
import {ProposalPageOrchestrator} from '../../../services/proposal/proposal-page.orchestrator';
import {ProtectionBuilderComponent} from '../../protection-builder/protection-builder.component';
import {NeedsReminderSectionComponent} from '../coverage-builder-section/needs-reminder-section/needs-reminder-section.component';

@Component({
  selector: 'em-protection-builder-section',
  templateUrl: './protection-builder-section.component.html',
  imports: [CardModule, NeedsReminderSectionComponent, ProtectionBuilderComponent],
})
export class ProtectionBuilderSectionComponent implements AfterViewInit {
  @Input({required: true}) set prefilledProtection(protection: Protection | undefined) {
    if (protection) {
      this.latestPrefilledCoverage = extractCoverageFromProtection(protection);
    }
  }

  @Input({required: true}) fullName!: string;
  @Input({required: true}) ratesVersion!: Version;
  @Input({required: true}) categoryCode!: CategoryCode;
  @Input({required: true}) age!: number;
  @Input({required: true}) smoker!: boolean;
  @Input({required: true}) sex!: Sex;
  @Input({required: true}) needs!: number;
  @Input({required: true}) completed!: boolean;
  @Input({required: true}) jobRiskClass: JobRiskClass | undefined;
  @Input() readonly = false;

  @Input() set willRequireExtraRequirements(willRequireExtraRequirements: boolean | undefined) {
    if (willRequireExtraRequirements && !this._willRequireExtraRequirements) {
      this.wasExtraRequirementsNoticeClosed = false;
    }

    this._willRequireExtraRequirements = willRequireExtraRequirements ?? false;
  }

  @Output() protectionReset = new EventEmitter<void>();

  latestPrefilledCoverage: Coverage | null = null;
  _willRequireExtraRequirements = false;
  wasExtraRequirementsNoticeClosed = false;

  constructor(private readonly orchestrator: ProposalPageOrchestrator) {}

  get prefilledCoverage(): Coverage | null {
    return this.latestPrefilledCoverage;
  }

  ngAfterViewInit(): void {
    if (
      this.completed == null ||
      this.needs == null ||
      this.age == null ||
      this.smoker == null ||
      !this.sex ||
      !this.ratesVersion ||
      !this.categoryCode
    ) {
      throw new Error('Missing required input');
    }
  }

  onProtectionBuilt(protection: Protection | undefined): void {
    if (!protection) {
      this.orchestrator
        .resetProtection()
        .pipe(first())
        .subscribe(() => this.protectionReset.emit());
      return;
    }

    this.orchestrator
      .update({coverage: extractCoverageFromProtection(protection)})
      .pipe(first())
      .subscribe();
  }

  closeExtraRequirementsNotice(): void {
    this.wasExtraRequirementsNoticeClosed = true;
  }
}
